<template>
    <SubpageHeader :pageId="categoryId" :website="videoData" :pageType="pageType" v-if="categoryId && pageType"></SubpageHeader>

    <transition name="fade" appear>
        <VideoDetail 
            v-if="videoData && videoData.website_id"
            :video="videoData" 
            :websiteId="videoData.website_id" 
            :videoId="videoData._id"
            :videoTitle="videoData.title"
            :pageType="pageType"
            :categoryId="categoryId"
        >
        </VideoDetail>
    </transition>
</template>

<script>
import axios from "axios";
import VideoDetail from "./VideoDetail";
import SubpageHeader from "../elements/SubpageHeader";

export default {
    name: "Video",
    components: {
        VideoDetail,
        SubpageHeader
    },
    data() {
        return {
            VIDEO_DATA: '/api/krainaabc/video?device=www&id=',
            videoData: []
        };
    },
    computed: {
        categoryId() {
            if(this.videoData && this.videoData.breadcrumbs && this.videoData.breadcrumbs[0] && this.videoData.breadcrumbs[0]._id) {
                return this.videoData.breadcrumbs[0]._id;
            }
            return null;
        },
        pageType() {
            if(this.$route.params.type) {
                return this.$route.params.type;
            } else {
                return window.__pageSettings.type;
            }
        },
        pageId() {
            if(this.$route.params.id) {
                return parseInt(this.$route.params.id);
            } else {
                return window.__pageSettings.id;
            }
        }
    },
    methods: {
        getVideoData() {
            axios
                .get(`${this.VIDEO_DATA}${this.pageId}`)
                .then((response) => {
                    if (response.status === 200) {
                        if(response.data && response.data.data) {
                            this.videoData = response.data.data;
                        }
                    } else {
                        this.$store.dispatch("changeModalErrorLoadingState", true);
                        this.$store.dispatch("changeModalBackdrop", true);                          
                    }
                })
                .catch(() => {
                    this.$store.dispatch("changeModalErrorLoadingState", true);
                    this.$store.dispatch("changeModalBackdrop", true);  
                });            
        }
    },
    mounted() {
        this.getVideoData();
    }
};
</script>